import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function SunDrenchedEleganceHero() {
  return <section data-section-id="226884" id="hero" className="relative w-full min-h-[500px] flex flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      {/* 背景画像 */}
      <div className="absolute inset-0 w-full h-full z-0">
        <img src="https://yotsuya-sc-room.com/wp-content/uploads/2026/05/share.jpg" alt="両手で若葉を包み込む様子。悩みを分かち合うイメージ" className="w-full h-full object-cover object-left" fetchPriority="high" decoding="async" />
        <div className="absolute inset-0 bg-black/5 z-10"></div>
      </div>

      {/* テキストブロック */}
      <div className="relative z-20 flex items-center justify-end w-full max-w-[1050px]">
        <div className="bg-white/40 backdrop-blur-md border-l border-white/50 shadow-2xl w-full flex flex-col justify-center animate-in fade-in slide-in-from-right-8 duration-1000 !m-0 px-4 sm:px-6 md:px-10 lg:px-14 py-12 md:py-14 min-h-[400px] md:min-h-[500px] md:w-1/2 md:max-w-lg">

          <h1 className="font-default tracking-tight leading-[1.4] !bg-transparent ![margin:0px_0px_24px_0px] ![padding:0px] !text-[rgba(51,62,53,1)] text-2xl w-full !not-italic !normal-case sm:text-3xl md:text-4xl"><span className="block text-sm sm:text-base font-normal tracking-wider mb-3 whitespace-nowrap">四谷・曙橋の心理カウンセリングルーム</span>悩みは、<br />一緒に持てば軽くなる</h1>

          <p className="font-default text-base mb-8 leading-relaxed tracking-wide !text-[rgba(75,85,76,1)] w-full !not-italic md:text-lg">どんな人も、生きているとさまざまな悩みを抱えます。ここは、そんな悩みを何でも話せる部屋です。素直な気持ちを言葉にして、見つめていきましょう。悩み事があったら、いつでもいらしてください。</p>

          <Button variant="ghost" size="lg" className="rounded-md px-10 py-6 text-base md:text-lg border border-teal-200 bg-white/60 text-primary hover:bg-teal-50/80 transition-all flex items-center justify-center gap-2 w-fit" asChild>
            <Link to="https://yotsuya-sc-room.com/reserve/">ご予約・お問い合わせ</Link>
          </Button>
        </div>
      </div>

      {/* スクロール誘導 */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-3 opacity-70 hover:opacity-100 transition-opacity">
        <div className="w-px h-16 bg-primary/40 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-primary animate-pulse"></div>
        </div>
      </div>
    </section>;
}